import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { displayNotify } from "../../../../../shared/services/Notifications/NotificationServices";

export default function useDeleteRequest(guID?: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (teamSlug?: string) => axios.delete(`/events/${guID}/registration/${teamSlug}/`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['eventRequests', guID] });
            displayNotify({
                status: 'success',
                title: 'Изменения сохранены',
                description: 'Заявка удалена'
            })
        }
    })
}